import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const inventoryItemTransferAPI = {
    getAll: async (
        page,
        pageSize,
        searchTerm, 
        sourceWarehouse, 
        destinationWarehouse, 
        sourceLocation, 
        destinationLocation, 
        startDate, 
        endDate, 
        inTransit,
        isCompleted,
        isCancelled,
        hasIssue,
        issueResolved
    ) => {
        try {
            const { data } = await api.get('/api/inventory-item-transfers', {
                params: { 
                    page, 
                    pageSize,
                    searchTerm, 
                    sourceWarehouse, 
                    destinationWarehouse, 
                    sourceLocation, 
                    destinationLocation, 
                    startDate, 
                    endDate,
                    inTransit,
                    isCompleted,
                    isCancelled,
                    hasIssue,
                    issueResolved
                }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all inventory item transfers error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/inventory-item-transfers/${id}`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get inventory item transfer by id error:');
        }
    },
    cancelTransfer: async (id, comments) => {
        try {
            const { data } = await api.post(`/api/inventory-item-transfers/cancel/${id}/`, { notes: comments });
            return data;
        } catch (error) {
            handleApiError(error, 'Cancel inventory item transfer error:');
        }
    },
    receiveTransfer: async (id, locationId, comments, receivedQuantity, hasQuantityDiscrepancy, preferredResolution) => {
        try {
            const { data } = await api.post(`/api/inventory-item-transfers/receive/${id}/`, { 
                newLocationId: locationId, 
                notes: comments,
                receivedQuantity: receivedQuantity,
                hasQuantityDiscrepancy: hasQuantityDiscrepancy,
                preferredResolution: preferredResolution
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Receive inventory item transfer error:');
        }
    }
};
